import { combineReducers } from "redux";
import { language } from "./language";
import { auth } from "./auth";
import { listCompanies, selectedCompany, fetchCompany } from "./companies";
import {
  listPickings,
  deletePicking,
  invoicePicking,
  updatePicking,
  allowShipPicking,
  paginatePickings,
  filterPickings,
  alterPicking,
  fetchPicking,
  paginatePickingsLog,
  exportPickingsLog,
  exportPickings
} from "./pickings";
import {
  createVehicle,
  deleteVehicle,
  fetchVehicle,
  listVehicles,
  paginateVehicles,
  updateVehicle,
} from "./settings/vehicles";
import {
  createVehicleType,
  deleteVehicleType,
  fetchVehicleType,
  listVehicleTypes,
  paginateVehicleTypes,
  updateVehicleType,
} from "./settings/vehicle-types";
import {
  createCompanyDock,
  deleteCompanyDock,
  fetchCompanyDock,
  fetchDock,
  listCompanyDocks,
  paginateCompanyDocks,
  updateCompanyDock,
} from "./settings/company-docks";
import {
  createJustification,
  deleteJustification,
  fetchJustification,
  listJustifications,
  paginateJustifications,
  updateJustification,
} from "./settings/justifications";
import {
  createBlockDate,
  deleteBlockDate,
  fetchBlockDate,
  paginateBlockDates,
  updateBlockDate,
} from "./settings/block-dates";
import { updateUser } from "./settings/users";
import {
  cancelTransport,
  calendarView,
  createTransport,
  deleteTransport,
  fetchTransport,
  exportTransports,
  listTransports,
  listAvailableTimeframes,
  listPanelTransports,
  paginateTransports,
  schedulingEdit,
  schedulingTransport,
  updateTransport,
  filterTransport,
  paginatePanel,
  justificateTransport,
  replyJustification,
  cancelManyTransport,
} from "./transports";
import { listClients, createClient } from "./clients";
import { listCarriers, createCarrier } from "./carriers";
import { createDockCarrier, deleteDockCarrier } from "./settings/dock-carrier";
import { listShippings } from "./shippings";
import { listProducts, fetchProduct } from "./products";
import {
  findOrCreateDriver,
  uploadVaccineCertificate,
  fetchVaccineCertificates,
} from "./drivers";
import {
  createPickingFile,
  deletePickingFile,
  listPickingFiles,
} from "./picking-files";

import {
  createPickingQuarentine,
  deletePickingQuarentine,
  fetchPickingQuarentine,
  listPickingQuarentines,
  paginatePickingQuarentines,
  updatePickingQuarentine,
} from "./picking-quarentines";

import {
  createBusiness,
  deleteBusiness,
  fetchBusiness,
  listBusiness,
  paginateBusiness,
  updateBusiness,
} from "./business";

import { listBoardingConditions } from "./boarding_conditions";
import { listCities } from "./cities";

import {
  createTransportFile,
  deleteTransportFile,
  listTransportFiles,
} from "./transport-files";

import { cep } from "./cep";
import { listClientTypes } from "./client-types";
import { fetchListCarrierContact } from "./carrier-contact";

import { fetchEmbedZohoUrl } from './zohoDashboard';

import {
  paginateOrdersFOB,
  fetchOrderFOB,
  updateOrderFOB,
  cancelScheduledOrderFOB,
  schedulingOrderFOB,
  fetchScheduledOrderFOB,
  updateScheduledOrderFOB,
  paginateScheduledOrdersFOB,
  createOrderFOB,
  filterOrderFOB,
  updateInvoiceOrderFOB,
  exportSchedulingOrderFOB,
  deleteOrderScheduledOrderFOB,
  deleteOrderFOB,
  importWriteOffFob,
  fetchFileSchedulingFob,
  uploadDeliveryReceiptSchedulingFOB
} from "./ordersFob";
import { printingData } from './printingData';
import { fetchInvoiceFile } from './invoices/fetch-invoice-file';
import { totemScheduling } from "./totem-scheduling";

const reducers = combineReducers({
  language,
  auth,
  listCompanies,
  selectedCompany,
  listPickings,
  deletePicking,
  invoicePicking,
  updatePicking,
  alterPicking,
  fetchPicking,
  allowShipPicking,
  paginatePickings,
  paginatePickingsLog,
  exportPickingsLog,
  exportPickings,
  filterPickings,
  createVehicle,
  deleteVehicle,
  fetchVehicle,
  listVehicles,
  paginateVehicles,
  updateVehicle,
  createVehicleType,
  deleteVehicleType,
  fetchVehicleType,
  listVehicleTypes,
  paginateVehicleTypes,
  updateVehicleType,
  createCompanyDock,
  deleteCompanyDock,
  fetchCompanyDock,
  fetchDock,
  listCompanyDocks,
  paginateCompanyDocks,
  updateCompanyDock,
  createJustification,
  deleteJustification,
  fetchJustification,
  listJustifications,
  paginateJustifications,
  updateJustification,
  cancelTransport,
  calendarView,
  createTransport,
  deleteTransport,
  fetchTransport,
  exportTransports,
  listAvailableTimeframes,
  listTransports,
  listPanelTransports,
  paginatePanel,
  paginateTransports,
  schedulingEdit,
  schedulingTransport,
  updateTransport,
  justificateTransport,
  replyJustification,
  filterTransport,
  listClients,
  listCarriers,
  createBlockDate,
  deleteBlockDate,
  fetchBlockDate,
  paginateBlockDates,
  updateBlockDate,
  createDockCarrier,
  deleteDockCarrier,
  listShippings,
  listProducts,
  fetchProduct,
  fetchCompany,
  findOrCreateDriver,
  uploadVaccineCertificate,
  fetchVaccineCertificates,
  createPickingFile,
  deletePickingFile,
  listPickingFiles,
  updateUser,
  createPickingQuarentine,
  deletePickingQuarentine,
  fetchPickingQuarentine,
  listPickingQuarentines,
  paginatePickingQuarentines,
  updatePickingQuarentine,
  createBusiness,
  deleteBusiness,
  fetchBusiness,
  listBusiness,
  paginateBusiness,
  updateBusiness,
  listBoardingConditions,
  listCities,
  createTransportFile,
  deleteTransportFile,
  listTransportFiles,
  createCarrier,
  cep,
  listClientTypes,
  createClient,
  cancelManyTransport,
  fetchListCarrierContact,

  // Orders Fob
  paginateOrdersFOB,
  fetchOrderFOB,
  updateOrderFOB,
  cancelScheduledOrderFOB,
  schedulingOrderFOB,
  fetchScheduledOrderFOB,
  updateScheduledOrderFOB,
  paginateScheduledOrdersFOB,
  createOrderFOB,
  filterOrderFOB,
  updateInvoiceOrderFOB,
  exportSchedulingOrderFOB,
  deleteOrderScheduledOrderFOB,
  deleteOrderFOB,
  importWriteOffFob,
  fetchFileSchedulingFob,
  uploadDeliveryReceiptSchedulingFOB,
  printingData,
  fetchEmbedZohoUrl,
  fetchInvoiceFile,
  totemScheduling,
});

export default reducers;
